const themes = (lightBackgroundImage, darkBackgroundImage) => ({
  light: {
    themeId: 'light',
    backgroundImage: lightBackgroundImage,
    titleTextColor: 'rgba(0,0,0,0.8)',
    messageTextColor: 'rgba(0,0,0,0.7)',
  },
  dark: {
    themeId: 'dark',
    backgroundImage: darkBackgroundImage,
    titleTextColor: 'rgba(255,255,255,0.9);',
    messageTextColor: 'rgba(255,255,255,0.8);',
  },
});

export default themes;
